<header-bar title="Routinen Anpassungen"></header-bar>
<div class="page-content">

  <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
    <div class="content" style="margin-bottom: 6px; margin-top: 0; padding-bottom: 72px">
      <section data-id="routineSettingsListContainer"></section>
    </div>
  </div>
  <div data-id="btnAction"
       class="clickable"
       style="position: fixed; z-index: 41; bottom: calc(env(safe-area-inset-bottom) + 82px); right: 10px; width: 48px; height: 48px; background-color: white;box-shadow: 0 8px 18px 0 rgba(0, 0, 0, 0.2) !important;border-radius:50px; text-align: center">
    <i class="fa fa-plus" style="margin-top: 16px; color: #4eb9aa; font-size: 18px; padding-right: 1px"></i>
  </div>

</div>
<main-menu></main-menu>
